import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Pos { x: number; y: number }

interface PanelPositionState {
  overviewPos: Pos | null;
  inspectPos: Pos | null;
  tutorialPos: Pos | null;
  tutorialMinimized: boolean;
  setOverviewPos: (pos: Pos | null) => void;
  setInspectPos: (pos: Pos | null) => void;
  setTutorialPos: (pos: Pos | null) => void;
  setTutorialMinimized: (minimized: boolean) => void;
}

export const usePanelPositionStore = create<PanelPositionState>()(
  persist(
    (set) => ({
      overviewPos: null,
      inspectPos: null,
      tutorialPos: null,
      tutorialMinimized: false,
      setOverviewPos: (pos) => set({ overviewPos: pos }),
      setInspectPos: (pos) => set({ inspectPos: pos }),
      setTutorialPos: (pos) => set({ tutorialPos: pos }),
      setTutorialMinimized: (minimized) => set({ tutorialMinimized: minimized }),
    }),
    {
      name: 'astra-panel-positions',
      // Keep panel positions across sessions, but always start the tutorial
      // panel expanded — minimize is a per-session UI state, not a setting.
      partialize: (state) => ({
        overviewPos: state.overviewPos,
        inspectPos: state.inspectPos,
        tutorialPos: state.tutorialPos,
      }),
    },
  ),
);
